import { useMemo, useState } from "react";
import { NotificationsBellView } from "./NotificationsBellView";
import { useNotificationsStore } from "@src/entities/notifications/model/store/notificationsStore";
import { notificationsSocket } from "@src/entities/notifications/model/ws/notificationsSocket";
import { useNavigate } from "react-router-dom";
import { NotificationsHistoryModal } from "@src/features/notificationsHistoryModal";

export function NotificationsBell() {
  const [open, setOpen] = useState(false);
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  const navigate = useNavigate();
  const items = useNotificationsStore((s) => s.items);
  const unreadCount = useNotificationsStore((s) => s.unreadCount);
  const markReadLocal = useNotificationsStore((s) => s.markReadLocal);

  const viewItems = useMemo(
    () => items.slice(0, 20).sort((a, b) => Number(b.id) - Number(a.id)),
    [items],
  );

  const handleOpenHistory = () => {
    setOpen(false);
    setIsHistoryOpen(true);
  };

  const handleCloseHistory = () => {
    setIsHistoryOpen(false);
  };

  return (
    <>
      <NotificationsBellView
        open={open}
        onToggle={() => setOpen((v) => !v)}
        onClose={() => setOpen(false)}
        items={viewItems}
        unreadCount={unreadCount}
        onItemClick={(id) => {
          const notification = items.find((item) => item.id === id);
          markReadLocal(id);
          notificationsSocket.markRead(id);
          setOpen(false);
          if (notification?.requestUuid) {
            navigate("/search-history", {
              state: { requestUuid: notification?.requestUuid },
            });
          }
        }}
        onShowAll={handleOpenHistory}
      />
      <NotificationsHistoryModal
        open={isHistoryOpen}
        onClose={handleCloseHistory}
      />
    </>
  );
}
